import { render, staticRenderFns } from "./carriage-form.vue?vue&type=template&id=426eee80&scoped=true"
import script from "./carriage-form.vue?vue&type=script&lang=js"
export * from "./carriage-form.vue?vue&type=script&lang=js"
import style0 from "./carriage-form.vue?vue&type=style&index=0&id=426eee80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426eee80",
  null
  
)

export default component.exports